import camelcaseKeys from "camelcase-keys";
import { PATTERNS } from "constants/appConstant";
import moment from "moment/moment";

export const createDurationOptions = (start, end, step) => {
  const options = [];
  for (let i = start; i <= end; i += step) {
    options.push({
      value: i,
      label: `${i} seconds`,
    });
  }
  return options;
};

export const toCamelCaseKey = obj => {
  if (Array.isArray(obj)) {
    return obj.map(v => toCamelCaseKey(v));
  } else if (obj !== null && obj.constructor === Object) {
    return Object.keys(obj).reduce(
      (result, key) => ({
        ...result,
        [camelcaseKeys(key)]: toCamelCaseKey(obj[key]),
      }),
      {}
    );
  }
  return obj;
};

export const converInputFileToArray = (data, listHeaders, setMaxCol) => {
  let headers = listHeaders;
  const line1 = data[0];
  const rows = data.slice(0);
  const maxCol = Math.max(...rows.map(row => row.length));
  const firstNames = [
    "first_name",
    "firstName",
    "first name",
    "First Name",
    "firstname",
  ];
  const lastNames = [
    "last_name",
    "lastName",
    "last name",
    "Last Name",
    "lastname",
  ];
  const emails = ["email", "Email"];
  const phones = [
    "phone",
    "Phone",
    "number_phone",
    "Number Phone",
    "number phone",
    "phone_number",
    "phone number",
    "Phone Number",
    "mobile_phone",
    "mobile phone",
    "Mobile Phone",
    "PhoneNumber",
  ];
  const images = [
    "image",
    "Image",
    "profile_image",
    "profileImage",
    "Profile Image",
  ];
  const facebooks = ["facebook", "Facebook"];
  const instagrams = ["instagram", "Instagram"];
  const twitters = ["twitter", "Twitter"];
  const snapchats = ["snapchat", "Snapchat"];
  if (line1.length > 0) {
    const arr = [];
    line1.map(item => {
      const head = item.trim().replaceAll("\r", "");
      if (firstNames.indexOf(head) !== -1) {
        arr.push("firstName");
      } else if (lastNames.indexOf(head) !== -1) {
        arr.push("lastName");
      } else if (emails.indexOf(head) !== -1) {
        arr.push("email");
      } else if (phones.indexOf(head) !== -1) {
        arr.push("phoneNumber");
      } else if (images.indexOf(head) !== -1) {
        arr.push("profileImage");
      } else if (facebooks.indexOf(head) !== -1) {
        arr.push("facebook");
      } else if (instagrams.indexOf(head) !== -1) {
        arr.push("instagram");
      } else if (twitters.indexOf(head) !== -1) {
        arr.push("twitter");
      } else if (snapchats.indexOf(head) !== -1) {
        arr.push("snapchat");
      }
    });
    if (arr.length > 0) {
      // headers = arr;
      let newHeaders = [...arr, ...listHeaders];
      let unique = [];
      newHeaders.forEach(element => {
        if (!unique.includes(element)) {
          unique.push(element);
        }
      });
      headers = unique;
    } else {
      headers = listHeaders;
    }
  }
  setMaxCol(maxCol);
  if (headers.length > maxCol) {
    headers.splice(maxCol, headers.length - maxCol);
  }
  const list = rows.map(function (row) {
    const values = row;
    // console.log("values", values);
    const objHaveValue = values.filter(vls => vls && vls.trim());
    // console.log("objHaveValue", objHaveValue);
    if (objHaveValue.length > 0) {
      if (values.length > 0) {
        if (values.length < maxCol) {
          values.push("");
        }
        let el = headers.reduce(function (object, header, index) {
          // console.log(header, values[index]);
          object[header] =
            values[index] !== "" &&
            values[index] !== undefined &&
            values[index].includes("\r")
              ? values[index].replaceAll("\r", "")
              : values[index];

          if (
            values[index] !== "" &&
            values[index] !== undefined &&
            values[index].includes("\r") &&
            values[index].replaceAll("\r", "").toString().includes("@")
          ) {
            if (!object.email) {
              const newField = { email: "" };
              Object.setPrototypeOf(object, newField);
            } else {
              object[header] = object.email;
              object["email"] =
                values[index] !== ""
                  ? values[index].replaceAll("\r", "")
                  : values[index];
            }
          } else if (
            values[index] !== "" &&
            values[index] !== undefined &&
            values[index].includes("\r") &&
            PATTERNS.PHONE_NUMBER_LENGTH.test(
              values[index].replaceAll("\r", "").toString()
            )
          ) {
            if (!object.phoneNumber) {
              const newField = { phoneNumber: "" };
              Object.setPrototypeOf(object, newField);
            } else {
              object[header] = object.phoneNumber;
              object["phoneNumber"] =
                values[index] !== ""
                  ? values[index].replaceAll("\r", "")
                  : values[index];
            }
          } else {
            object[header] = values[index];
          }

          return object;
        }, {});
        if (headers.length < maxCol) {
          // console.log("values.length", values.length, maxCol);
          // add new value for ignore col
          for (let i = headers.length; i < maxCol; i++) {
            // console.log("values", i, values[i]);
            el[`ignore${i}`] = values[i];
          }
        }
        headers.map(head => {
          if (
            el[head] !== "" &&
            el[head] !== undefined &&
            el[head].toString().includes("@") &&
            head !== "email"
          ) {
            const val = el.email;
            el.email = el[head];
            el[head] = val;
          }
          if (
            el[head] !== "" &&
            el[head] !== undefined &&
            PATTERNS.PHONE_NUMBER_LENGTH.test(el[head].toString()) &&
            head !== "phoneNumber"
          ) {
            const val = el.phoneNumber;
            el.phoneNumber = el[head];
            el[head] = val;
          }
        });
        // console.log("el", el);
        return el;
      }
    }
  });

  headers.map(head => {
    const line1 = list[0];
    if (line1[head]) {
      if (firstNames.indexOf(line1[head]) !== -1) {
        const item = line1["firstName"];
        line1["firstName"] = line1[head];
        line1[head] = item;
      }
      if (lastNames.indexOf(line1[head]) !== -1) {
        const item = line1["lastName"];
        line1["lastName"] = line1[head];
        line1[head] = item;
      }
      if (emails.indexOf(line1[head]) !== -1) {
        const item = line1["email"];
        line1["email"] = line1[head];
        line1[head] = item;
      }
      if (phones.indexOf(line1[head].trim()) !== -1) {
        const item = line1["phoneNumber"];
        line1["phoneNumber"] = line1[head];
        line1[head] = item;
      }
      // if (images.indexOf(line1[head]) !== 1) {
      //   console.log("5");
      //   const item = line1["profileImage"];
      //   line1["profileImage"] = line1[head];
      //   line1[head] = item;
      // }
      if (facebooks.indexOf(line1[head]) !== -1) {
        const item = line1["facebook"];
        line1["facebook"] = line1[head];
        line1[head] = item;
      }
      if (instagrams.indexOf(line1[head]) !== -1) {
        const item = line1["instagram"];
        line1["instagram"] = line1[head];
        line1[head] = item;
      }
      if (twitters.indexOf(line1[head]) !== -1) {
        const item = line1["twitter"];
        line1["twitter"] = line1[head];
        line1[head] = item;
      }
      if (snapchats.indexOf(line1[head]) !== -1) {
        const item = line1["snapchat"];
        line1["snapchat"] = line1[head];
        line1[head] = item;
      }
    }
  });
  return list.filter(item => item !== undefined);
};

export const covertFileToArray = async (
  data,
  delimeter,
  listHeaders,
  setMaxCol
) => {
  const fileUrl = URL.createObjectURL(data.file);
  const response = await fetch(fileUrl);
  const text = await response.text();
  console.log("text", text);
  const lines = text.split("\n");
  console.log("line", lines);
  const arr = lines.map(line => line.split(`${delimeter}`));

  let headers = listHeaders;
  console.log("headers", headers);
  const rows = arr.slice(0);
  const maxCol = Math.max(...rows.map(row => row.length));
  console.log("maxCol", maxCol);
  const line1 = lines[0].split(",");
  const firstNames = [
    "first_name",
    "firstName",
    "first name",
    "First Name",
    "firstname",
  ];
  const lastNames = [
    "last_name",
    "lastName",
    "last name",
    "Last Name",
    "lastname",
  ];
  const emails = ["email", "Email"];
  const phones = [
    "phone",
    "Phone",
    "number_phone",
    "Number Phone",
    "number phone",
    "phone_number",
    "phone number",
    "Phone Number",
    "mobile_phone",
    "mobile phone",
    "Mobile Phone",
    "PhoneNumber",
  ];
  const images = [
    "image",
    "Image",
    "profile_image",
    "profileImage",
    "Profile Image",
  ];
  const facebooks = ["facebook", "Facebook"];
  const instagrams = ["instagram", "Instagram"];
  const twitters = ["twitter", "Twitter"];
  const snapchats = ["snapchat", "Snapchat"];
  if (line1.length > 0) {
    const arr = [];
    line1.map(item => {
      const head = item.trim().replaceAll("\r", "");
      if (firstNames.indexOf(head) !== -1) {
        arr.push("firstName");
      } else if (lastNames.indexOf(head) !== -1) {
        arr.push("lastName");
      } else if (emails.indexOf(head) !== -1) {
        arr.push("email");
      } else if (phones.indexOf(head) !== -1) {
        arr.push("phoneNumber");
      } else if (images.indexOf(head) !== -1) {
        arr.push("profileImage");
      } else if (facebooks.indexOf(head) !== -1) {
        arr.push("facebook");
      } else if (instagrams.indexOf(head) !== -1) {
        arr.push("instagram");
      } else if (twitters.indexOf(head) !== -1) {
        arr.push("twitter");
      } else if (snapchats.indexOf(head) !== -1) {
        arr.push("snapchat");
      }
    });
    if (arr.length > 0) {
      // headers = arr;
      let newHeaders = [...arr, ...listHeaders];
      let unique = [];
      newHeaders.forEach(element => {
        if (!unique.includes(element)) {
          unique.push(element);
        }
      });
      headers = unique;
    } else {
      headers = listHeaders;
    }
  }
  setMaxCol(maxCol);
  // console.log("rows", rows);
  if (headers.length > maxCol) {
    headers.splice(maxCol, headers.length - maxCol);
  }
  const list = rows.map(function (row) {
    const values = row;
    // console.log("values", values);
    const objHaveValue = values.filter(vls => vls && vls.trim());
    // console.log("objHaveValue", objHaveValue);
    if (objHaveValue.length > 0) {
      if (values.length > 0) {
        if (values.length < maxCol) {
          values.push("");
        }
        let el = headers.reduce(function (object, header, index) {
          // console.log(header, values[index]);
          object[header] =
            values[index] !== "" &&
            values[index] !== undefined &&
            values[index].includes("\r")
              ? values[index].replaceAll("\r", "")
              : values[index];

          if (
            values[index] !== "" &&
            values[index] !== undefined &&
            values[index].includes("\r") &&
            values[index].replaceAll("\r", "").toString().includes("@")
          ) {
            if (!object.email) {
              const newField = { email: "" };
              Object.setPrototypeOf(object, newField);
            } else {
              object[header] = object.email;
              object["email"] =
                values[index] !== ""
                  ? values[index].replaceAll("\r", "")
                  : values[index];
            }
          } else if (
            values[index] !== "" &&
            values[index] !== undefined &&
            values[index].includes("\r") &&
            PATTERNS.PHONE_NUMBER_LENGTH.test(
              values[index].replaceAll("\r", "").toString()
            )
          ) {
            if (!object.phoneNumber) {
              const newField = { phoneNumber: "" };
              Object.setPrototypeOf(object, newField);
            } else {
              object[header] = object.phoneNumber;
              object["phoneNumber"] =
                values[index] !== ""
                  ? values[index].replaceAll("\r", "")
                  : values[index];
            }
          } else {
            object[header] = values[index];
          }

          return object;
        }, {});
        if (headers.length < maxCol) {
          // console.log("values.length", values.length, maxCol);
          // add new value for ignore col
          for (let i = headers.length; i < maxCol; i++) {
            // console.log("values", i, values[i]);
            el[`ignore${i}`] = values[i];
          }
        }
        headers.map(head => {
          if (
            el[head] !== "" &&
            el[head] !== undefined &&
            el[head].toString().includes("@") &&
            head !== "email"
          ) {
            const val = el.email;
            el.email = el[head];
            el[head] = val;
          }
          if (
            el[head] !== "" &&
            el[head] !== undefined &&
            PATTERNS.PHONE_NUMBER_LENGTH.test(el[head].toString()) &&
            head !== "phoneNumber"
          ) {
            const val = el.phoneNumber;
            el.phoneNumber = el[head];
            el[head] = val;
          }
        });
        // console.log("el", el);
        return el;
      }
    }
  });
  // list.filter(item => item !== undefined);
  headers.map(head => {
    const line1 = list[0];
    if (line1[head]) {
      if (firstNames.indexOf(line1[head]) !== -1) {
        const item = line1["firstName"];
        line1["firstName"] = line1[head];
        line1[head] = item;
      }
      if (lastNames.indexOf(line1[head]) !== -1) {
        const item = line1["lastName"];
        line1["lastName"] = line1[head];
        line1[head] = item;
      }
      if (emails.indexOf(line1[head]) !== -1) {
        const item = line1["email"];
        line1["email"] = line1[head];
        line1[head] = item;
      }
      if (phones.indexOf(line1[head].trim()) !== -1) {
        const item = line1["phoneNumber"];
        line1["phoneNumber"] = line1[head];
        line1[head] = item;
      }
      // if (images.indexOf(line1[head]) !== 1) {
      //   console.log("5");
      //   const item = line1["profileImage"];
      //   line1["profileImage"] = line1[head];
      //   line1[head] = item;
      // }
      if (facebooks.indexOf(line1[head]) !== -1) {
        const item = line1["facebook"];
        line1["facebook"] = line1[head];
        line1[head] = item;
      }
      if (instagrams.indexOf(line1[head]) !== -1) {
        const item = line1["instagram"];
        line1["instagram"] = line1[head];
        line1[head] = item;
      }
      if (twitters.indexOf(line1[head]) !== -1) {
        const item = line1["twitter"];
        line1["twitter"] = line1[head];
        line1[head] = item;
      }
      if (snapchats.indexOf(line1[head]) !== -1) {
        const item = line1["snapchat"];
        line1["snapchat"] = line1[head];
        line1[head] = item;
      }
    }
  });
  console.log("list", list);
  // return the array
  return list.filter(item => item !== undefined);
};

export const formatBytes = (bytes, decimals = 2) => {
  if (!+bytes) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

const getHashOfString = str => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  hash = Math.abs(hash);
  return hash;
};

const normalizeHash = (hash, min, max) => {
  return Math.floor((hash % (max - min)) + min);
};

export const generateUniqueColor = (_name = "") => {
  const hRange = [0, 360];
  const sRange = [30, 60];
  const lRange = [40, 70];

  const hash = getHashOfString(_name);
  const h = normalizeHash(hash, hRange[0], hRange[1]);
  const s = normalizeHash(hash, sRange[0], sRange[1]);
  const l = normalizeHash(hash, lRange[0], lRange[1]);

  return `hsl(${h}, ${s}%, ${l}%)`;
};

export const getCurrentDayOfWeek = number => {
  let day = "";
  switch (number) {
    case 1:
      day = "MONDAY";
      break;
    case 2:
      day = "TUESDAY";
      break;
    case 3:
      day = "WEDNESDAY";
      break;
    case 4:
      day = "THURSDAY";
      break;
    case 5:
      day = "FRIDAY";
      break;
    case 6:
      day = "SATURDAY";
      break;
    case 7:
      day = "SUNDAY";
      break;
  }
  return day;
};

export const renderWeeklyLabel = number => {
  let day = "";
  switch (number) {
    case 1:
      day = "Weekly on Monday";
      break;
    case 2:
      day = "Weekly on Tuesday";
      break;
    case 3:
      day = "Weekly on Wednesday";
      break;
    case 4:
      day = "Weekly on Thursday";
      break;
    case 5:
      day = "Weekly on Friday";
      break;
    case 6:
      day = "Weekly on Saturday";
      break;
    case 7:
      day = "Weekly on Sunday";
      break;
  }
  return day;
};

export const renderAnnually = () => {
  let label = moment.utc().local(new Date()).format("MMMM");
  const month = moment.utc().local(new Date()).month() + 1;
  const date = moment.utc().local(new Date()).date();
  switch (month) {
    case 1:
      label = `Annually on January ${date}`;
      break;
    case 2:
      label = `Annually on February ${date}`;
      break;
    case 3:
      label = `Annually on March ${date}`;
      break;
    case 4:
      label = `Annually on April ${date}`;
      break;
    case 5:
      label = `Annually on May ${date}`;
      break;
    case 6:
      label = `Annually on June ${date}`;
      break;
    case 7:
      label = `Annually on July ${date}`;
      break;
    case 8:
      label = `Annually on August ${date}`;
      break;
    case 9:
      label = `Annually on September ${date}`;
      break;
    case 10:
      label = `Annually on October ${date}`;
      break;
    case 11:
      label = `Annually on November ${date}`;
      break;
    case 12:
      label = `Annually on December ${date}`;
      break;
  }
  return label;
};

export const DAYS_OF_WEEK = [
  {
    key: "sun",
    label: "S",
    title: "Sunday",
    value: "SUNDAY",
    isChoose: false,
  },
  {
    key: "mon",
    label: "M",
    title: "Monday",
    value: "MONDAY",
    isChoose: false,
  },
  {
    key: "tue",
    label: "T",
    title: "Tuesday",
    value: "TUESDAY",
    isChoose: false,
  },
  {
    key: "wed",
    label: "W",
    title: "Wednesday",
    value: "WEDNESDAY",
    isChoose: false,
  },
  {
    key: "thu",
    label: "T",
    title: "Thursday",
    value: "THURSDAY",
    isChoose: false,
  },
  {
    key: "fri",
    label: "F",
    title: "Friday",
    value: "FRIDAY",
    isChoose: false,
  },
  {
    key: "sat",
    label: "S",
    title: "Saturday",
    value: "SATURDAY",
    isChoose: false,
  },
];
export const OPTIONS_REPEAT = [
  {
    value: "DAY",
    label: "Day",
  },
  {
    value: "WEEK",
    label: "Week",
  },
  {
    value: "MONTH",
    label: "Month",
  },
  {
    value: "YEAR",
    label: "Year",
  },
  {
    value: "DAYS",
    label: "Days",
  },
  {
    value: "WEEKS",
    label: "Weeks",
  },
  {
    value: "MONTHS",
    label: "Months",
  },
  {
    value: "YEARS",
    label: "Years",
  },
];
